import {NotificationMessage} from "./NotificationMessage";
import {Link} from "react-router-dom";
import React from "react";

export const NewMemberDiscussionCommentNotification = ({ notification }) => {
    const discussion = notification.entities.find((dataEntity) => dataEntity.type === 'member-discussion').data;
    const comment = notification.entities.find((dataEntity) => dataEntity.type === 'comment').data;
    const discussionId = discussion.id;
    const message = notification.message;
    const linkTo = '/community/member-discussions/' + discussionId;

    return (
        <div style={{display: "flex", flexDirection: "column"}}>
            <NotificationMessage
                message={message}
                linkTo={linkTo}
            />
            <Link to={'/comments/' + comment.id} className="notification__masterclass-comment__comment-text">
                {comment?.body}
            </Link>
        </div>
    );
};